import { render } from "./JoinDistributor.vue?vue&type=template&id=52f83212"
import script from "./JoinDistributor.vue?vue&type=script&lang=js"
export * from "./JoinDistributor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__